// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__5zkHm","me":"styles_me__jjj_U","page":"styles_page__q4NNY","text":"styles_text__JMWPH","photo":"styles_photo__NB3B7"};